import {ProcessFlowchartPlatformFeatureType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {
  DefaultProcessFlowchartNodeAdapter,
  ProcessFlowchartTaskSchemaNodeAdapter,
} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/nodes/ProcessFlowchartNodeAdapter';

import {getAdapterForNode} from './adapterUtils';
import getAllNodeDetailsSidepanelTabsForTaskNode from './getAllNodeDetailsSidepanelTabsForTaskNode';
import {
  FlowchartNode,
  isInteractivePlaceholderNode,
  isInteractiveTaskNode,
} from './processFlowchartConfigEditorNodeTypes';

/**
 * Determines whether a node has right sidepanel content that can be displayed.
 * Uses the node's adapter to check for sidepanel content.
 *
 * @param node - The flowchart node to check
 * @param platformFlowchartFeatures - Platform features map (required for task schema nodes)
 * @returns true if the node has sidepanel content, false otherwise
 */
export default function doesNodeHaveRightSidepanelContent(
  node: FlowchartNode,
  platformFlowchartFeatures?: Map<ProcessFlowchartPlatformFeatureType, boolean>
): boolean {
  if (isInteractivePlaceholderNode(node)) {
    return true;
  }

  const adapter = getAdapterForNode(node);
  if (adapter == null) {
    return false;
  }

  if (adapter instanceof ProcessFlowchartTaskSchemaNodeAdapter) {
    if (!isInteractiveTaskNode(node)) {
      return false;
    }
    const tabs = getAllNodeDetailsSidepanelTabsForTaskNode(node, platformFlowchartFeatures);
    return tabs.length > 0;
  }

  if (adapter instanceof DefaultProcessFlowchartNodeAdapter) {
    return adapter.nodeDetailsSidepanelContent(node) != null;
  }

  return false;
}
